module.exports = __webpack_public_path__ + "static/img/zhong16.ad6d5bf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/zhong16.png
// module id = nrTX
// module chunks = 16